export const ON_SAVE_PROFILE_UNITS = "ON_SAVE_PROFILE_UNITS";

export const saveProfileUnits = (payload) => {
  return {
    type: ON_SAVE_PROFILE_UNITS,
    payload,
  };
};
